import { cacheConfig, http } from '../helpers/axiosHelper';

export default class JourneyStateService {
   async getJourneyStates() {
      return http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey-state', { ...cacheConfig }).then((response) => {
         return response.data;
      });
   }
}
